export default "__VITE_ASSET__ZmKE2p2j__"